<ph-toolbar [formGroup]="formGroup">
    <ph-select
        [formControlName]="controlName"
        ngDefaultControl
        [items]="accountItems"
        [placeholder]="placeholder"
        aria-label="Payment bank account"
        (ph-change)="selectedBankChanged($event.detail)"
    ></ph-select>
</ph-toolbar>
